import axios from 'axios'

let defaultConfig = {
  version: 'v1',
  secure: true,
}

/**
 * @return {string}
 */
let ApiUrl = function (version = 'v1', secure = false) {

  let protocol = window.location.protocol
  let hostname = window.location.hostname

  // Force https manually, otherwise use default
  if (secure) {
    protocol = 'https:'
  }

  return protocol + '//' + hostname + '/api/' + version + '/'
}

/**
 * Generate Axios Instance with automatic baseUrl resolution.
 * Also enable withCredentials to allow cookies to be sent for Auth.
 *
 * @param version
 * @param secure
 * @returns {AxiosInstance}
 * @constructor
 */
let ApiFactory = function (version = 'v1', secure = false) {
  return axios.create({
    baseURL: ApiUrl(version, secure),
    withCredentials: true,
  })
}


const Api = {
  install(Vue, options) {

    let config = Object.assign(defaultConfig, options)

    Vue.prototype.$apiUrl = ApiUrl(config.version, config.secure)
    Vue.prototype.$api = ApiFactory(config.version, config.secure)
  },
}

export default Api